// abl-Custom-slideshow
$(document).ready(function () {
    var $slider = $('.ab-slide-wrap .slideshow');
    var slideCount = $slider.find('.slide').length;

    if (slideCount > 1) {
      $('.ab-slide-arrows').show();

      $('.arrow-next').on('click', function () {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickNext');
        }
      });

      $('.arrow-prev').on('click', function () {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickPrev');
        }
      });

    } else {
      $('.ab-slide-arrows').hide();
    }


    
});


